import { inboxTemplatesConstants } from '@constants/inbox-templates';

const initialState = {
    data: [],
    loading: true,
};

export function inboxTemplates(state = initialState, action) {
    switch (action.type) {
        case inboxTemplatesConstants.INBOX_TEMPLATES_REQUEST:
            return { ...state, loading: true };
        case inboxTemplatesConstants.INBOX_ALL_ACTIVE_TEMPLATES_SUCCESS:
            return { ...state, data: action.data.items, loading: false };
        case inboxTemplatesConstants.INBOX_TEMPLATES_ERROR:
            return { ...state, data: [], loading: false };
        default:
            return state;
    }
}
